var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));

export { AnimationType };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/utils/types.js
// module id = 21
// module chunks = 0